import { useState } from 'react';

import { useLocation, useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';

import { fakeDelay, linkCheckSlash } from '../../provider/utility';
import { selectedService } from '../../store/actions';
import FormLabel from '../FormLabel/FormLabel';
import SelectOption from '../SelectOption/SelectOption';
import SingleInputPage from './SingleInputPage/SingleInputPage';

export default function ServicePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const currentPage = useSelector((store) => store.state.page);

  const serviceFormLabel = useSelector((store) => store.data.serviceFormLabel);
  const availableServices = useSelector((store) => store.data.services);
  const currentService = useSelector((store) => store.state.service);

  const handleSelection = (item) => {
    dispatch(selectedService(item));
    setLoading(true);
    fakeDelay(() => {
      navigate(linkCheckSlash(location.pathname, item.value));
    });
  };

  const content = (
    <div>
      <FormLabel type="big">{serviceFormLabel}</FormLabel>
      <SelectOption
        items={availableServices}
        selected={currentService}
        onClick={handleSelection}
        displayPrimaryButton={true}
      />
    </div>
  );

  return (
    <SingleInputPage
      setLoading={setLoading}
      page={currentPage}
      currentStep={currentPage.step}
      content={content}
      backButton={false}
      nextButton={currentService && !loading}
      nextButtonLink={linkCheckSlash(location.pathname, currentService?.value)}
      loading={loading}
    />
  );
}
